import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { analyzerDate, offices, reports, searchID } from "@signals"

export default function AppDatesAutocomplete({ autoSelect = true, ...props }) {
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		value={analyzerDate.value}
		onChange={e => analyzerDate.value = e.target.value}
		label="Dates"
		placeholder="All Dates"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/pickup-dates`}
		onAjax={options => options.map(({ value, label }) => ({
			value: value,
			label: label
		}))}
		onFinishAjax={options => {
			if (autoSelect) {
				analyzerDate.value = options[0]?.value || null
			}
		}}
		filters={{
			reportExecutionID: reports.value,
			officePickupID: offices.value,
			searchID: searchID.value
		}}
		{...props}
	/>
}